import { OrderGroupDetailed } from 'src/reactQuery/orders/interfaces/orderGroup.interface';
import { API_URL_M7, getCachedSessionId } from 'src/services/common';
import { apiM7 } from 'src/util/axios-instance';

export const downloadOrdersCsv = async (params: {
  itemId: string;
  itemName: string;
  projectId: string;
}): Promise<OrderGroupDetailed[] | undefined> => {
  const { projectId, itemId, itemName } = params;

  const response = await apiM7.post<OrderGroupDetailed[]>(
    `${API_URL_M7}/api_admin/v1/project/${projectId}/ecommerce/order/csv/${itemId}`,
    {},
    {
      headers: { 'x-session-id': getCachedSessionId() }
    }
  );

  // @ts-ignore
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${itemName} orders.csv`);
  document.body.appendChild(link);
  link.click();

  return response.data;
};
